<template>

  <div class='card mb-3'>
    <div class='card-header border-0 pb-0'>
      <div class='d-flex flex-row'>
        <span v-text="$ml.get('helpTitle')"></span>
      </div>
      <img class="img-support" src='../assets/images/support.png'/> 
    </div> 
    <div v-if="typeUser == 'company'"  class='card-footer footer-helper p-3 d-flex flex-column justify-content-left'>
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'lifeCicle' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('programLifeCycle')">Ciclo de vida de um programa</span>
      </router-link>  
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'publicOrPrivate' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('helpDifference')"></span>
      </router-link>  
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'whatBounty' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('whatIsBugBounty')">O que é Bug Bounty</span>
      </router-link> 
    </div> 

    <div v-if="typeUser == 'hacker'" class='card-footer footer-helper p-3 d-flex flex-column justify-content-left'>
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'whatBounty' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('whatIsBugBounty')">O que é Bug Bounty</span>
      </router-link>  
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'item2' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('bugBountyAndTheSecurityParadox')">Bug Bounty e o paradoxo da Segurança</span>
      </router-link>  
      <router-link tag="a" :to="{ name: 'wiki', params: { item: 'item3' }}" class='d-flex pt-1 pb-1'>
        <span v-text="$ml.get('interviewWithExpertIgorRincon')">Entrevista com especialista Igor Rincon</span>
      </router-link>  
    </div> 
  </div> 
</template>
<script>  
export default { 
  components: {  
  },
  data() {
    return { 
      title: "Dashboard", 
    };
  }, 
  
  computed: {
    typeUser() {
      return this.$store.getters['getUserType'];
    } 
  },
};
</script>
